import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { CONTACT } from '../data/modalities';
const NAV = [{
  label: 'Home',
  to: '/'
}, {
  label: 'Products',
  to: '/#products'
}, {
  label: 'Product of the Month',
  to: '/#product-of-the-month'
}, {
  label: 'Concierge Suite',
  to: '/#concierge'
}, {
  label: 'Used Equipment',
  to: '/#used-equipment'
}, {
  label: 'About',
  to: '/about'
}, {
  label: 'Contact',
  to: '/contact'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  return <header className="sticky top-0 z-50 w-full border-b border-white/15 bg-navy text-white shadow-[0_8px_24px_-16px_rgba(9,10,42,0.8)]" data-id="element-55" data-mp="369qnhtr4lbpk">
      <div className="mx-auto flex h-[82px] max-w-7xl items-center justify-between px-5 sm:px-8" data-id="element-56" data-mp="3b8bovwi461fl">
        <Link to="/" aria-label="JAG Medical Solutions home" onClick={() => setOpen(false)} className="rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy" data-id="element-57" data-mp="3f9dqgjzi6pkq">
          <Logo data-id="element-58" data-mp="2hnlhsykmaiwm" />
        </Link>

        <nav className="hidden items-center gap-4 2xl:gap-5 2xl:flex" aria-label="Primary" data-id="element-59" data-mp="2hodg4h5lmuql">
          {NAV.map(item => {
          const active = item.to === '/' ? location.pathname === '/' && !location.hash : location.pathname === item.to;
          return <Link key={item.to} to={item.to} className={`relative py-2 text-[12px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy ${active ? 'text-teal-light' : 'text-white/80 hover:text-teal-light'}`} data-id="element-60" data-mp="35jg3slso2s5h">
                {item.label}
                {active && <span className="absolute bottom-0 left-0 h-0.5 w-full bg-teal" data-id="element-61" data-mp="1wcxn2ruqe6xc" />}
              </Link>;
        })}
        </nav>

        <div className="flex items-center gap-3" data-id="element-62" data-mp="1hlxg6r9mul3b">
          <a href={CONTACT.phoneHref} className="hidden items-center gap-2 rounded-full bg-teal px-5 py-2.5 text-[13.5px] font-semibold text-white transition-colors hover:bg-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-navy sm:inline-flex" data-id="element-63" data-mp="1mltatzwfx067">
            <PhoneIcon className="h-4 w-4" data-id="element-64" data-mp="13nqpbv33pld5" />
            Call {CONTACT.phone}
          </a>
          <button type="button" className="inline-flex h-10 w-10 items-center justify-center rounded-lg text-white transition-colors hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy 2xl:hidden" onClick={() => setOpen(value => !value)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-id="element-65" data-mp="2t2x5rf4liltn">
            {open ? <XIcon className="h-6 w-6" data-id="element-66" data-mp="re12wiuos329" /> : <MenuIcon className="h-6 w-6" data-id="element-67" data-mp="rcg5mlgzm60p" />}
          </button>
        </div>
      </div>

      {open && <div className="border-t border-white/15 bg-navy 2xl:hidden" data-id="element-68" data-mp="10631ebl7399w">
          <nav className="mx-auto flex max-w-7xl flex-col px-5 py-3 sm:px-8" aria-label="Mobile" data-id="element-69" data-mp="105tamlsbsy35">
            {NAV.map(item => <Link key={item.to} to={item.to} onClick={() => setOpen(false)} className="border-b border-white/10 py-3 text-[15px] font-medium text-white/85 transition-colors hover:text-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-inset" data-id="element-70" data-mp="1a5ad6uca6vuw">
                {item.label}
              </Link>)}
            <a href={CONTACT.phoneHref} onClick={() => setOpen(false)} className="mt-4 inline-flex items-center justify-center gap-2 rounded-full bg-teal px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-71" data-mp="27zusrjztvskf">
              <PhoneIcon className="h-4 w-4" data-id="element-72" data-mp="1p824g2vpevj1" />
              Call {CONTACT.phone}
            </a>
          </nav>
        </div>}
    </header>;
}